export default [
  "Akupunktur",
  "Allgemeinchirurg",
  "Allgemeine Chirurgie",
  "Allgemeiner Arzt",
  "Allgemeinmedizin",
  "Allgemeinmediziner",
  "Anästhesiologie",
  "Anästhesist",
  "Anatomie",
  "Andrologie",
  "Angiologe",
  "Angiologie",
  "Arbeitsmedizin",
  "Arbeitsmediziner",
  "Augenarzt",
  "Augenheilkunde",
  "Biochemie",
  "Bluthochdruckfacharzt",
  "Chirurg",
  "Chirurgie",
  "Dermatologe",
  "Dermatologie",
  { value: "Diabetologe", id: "herz" },
  { value: "Diabetologie", id: "herz" },
  "Endokrinologie",
  { value: "Endokrinologie und Diabetologie", id: "herz" },
  "Facharzt für Allgemeine Chirurgie",
  "Facharzt für Allgemeinmedizin",
  "Facharzt für Anästhesiologie",
  "Facharzt für Anatomie",
  "Facharzt für Andrologie",
  "Facharzt für Arbeitsmedizin",
  "Facharzt für Augenheilkunde",
  "Facharzt für Biochemie",
  "Facharzt für Chirurgie",
  "Facharzt für Dermatologie",
  { value: "Facharzt für Forensische Psychiatrie", id: "mental" },
  "Facharzt für Frauenheilkunde und Geburtshilfe",
  "Facharzt für Gefäßchirurgie",
  "Facharzt für Gefässchirurgie",
  "Facharzt für Gereatrie",
  "Facharzt für Gynäkologische Endokrinologie und Reproduktionsmedizin",
  "Facharzt für Gynäkologische Onkologie",
  "Facharzt für Hals-Nasen-Ohrenheilkunde",
  "Facharzt für Haut- und Geschlechtskrankheiten",
  { value: "Facharzt für Herzchirurgie", id: "herz" },
  "Facharzt für Humangenetik",
  "Facharzt für Hygiene und Umweltmedizin",
  "Facharzt für Innere Medizin",
  "Facharzt für Innere Medizin und Angiologie",
  {
    value: "Facharzt für Innere Medizin und Endokrinologie und Diabetologie",
    id: "herz",
  },
  "Facharzt für Innere Medizin und Gastroenterologie",
  "Facharzt für Innere Medizin und Hämatologie und Onkologie",
  "Facharzt für Innere Medizin und Kardiologie",
  "Facharzt für Innere Medizin und Nephrologie",
  "Facharzt für Innere Medizin und Pneumologie",
  "Facharzt für Innere Medizin und Rheumatologie",
  "Facharzt für Innere und Allgemeinmedizin",
  "Facharzt für Kinder- und Jugendmedizin",
  {
    value: "Facharzt für Kinder- und Jugendpsychiatrie und -psychotherapie",
    id: "mental",
  },
  "Facharzt für Kinder-Hämatologie und –Onkologie",
  "Facharzt für Kinder-Kardiologie",
  "Facharzt für Kinderchirurgie",
  "Facharzt für Kinderradiologie",
  "Facharzt für Klinische Pharmakologie",
  "Facharzt für Laboratoriumsmedizin",
  "Facharzt für Mikrobiologie, Virologie und Infektionsepidemiologie",
  "Facharzt für Mund-Kiefer-Gesichtschirurgie",
  "Facharzt für Neonatologie",
  { value: "Facharzt für Neurochirurgie", id: "mental" },
  { value: "Facharzt für Neurologie", id: "mental" },
  { value: "Facharzt für Neuropädiatrie", id: "mental" },
  { value: "Facharzt für Neuropathologie", id: "mental" },
  "Facharzt für Nuklearmedizin",
  "Facharzt für Orthopädie und Unfallchirurgie",
  "Facharzt für Palliativmedizin",
  "Facharzt für Pathologie",
  "Facharzt für Pharmakologie und Toxikologie",
  "Facharzt für Physikalische und Rehabilitative Medizin",
  "Facharzt für Physiologie",
  "Facharzt für Plastische und Ästhetische Chirurgie",
  { value: "Facharzt für Psychiatrie und Psychotherapie", id: "mental" },
  {
    value: "Facharzt für Psychosomatische Medizin und Psychotherapie",
    id: "mental",
  },
  "Facharzt für Radiologie",
  "Facharzt für Rechtsmedizin",
  "Facharzt für Spezielle Geburtshilfe und Perinatalmedizin",
  "Facharzt für Sportmedizin",
  "Facharzt für Sprach-, Stimm- und kindliche Hörstörungen",
  "Facharzt für Stomatologie",
  "Facharzt für Strahlentherapie",
  "Facharzt für Thoraxchirurgie",
  "Facharzt für Transfusionsmedizin",
  "Facharzt für Tropenmedizin",
  "Facharzt für Urologie",
  "Facharzt für Viszeralchirurgie",
  { value: "Fachzahnarzt für Kieferorthopädie", id: "kiefer" },
  { value: "Fachzahnarzt für Oralchirurgie", id: "zahn" },
  { value: "Fachzahnarzt für Paradontologie", id: "zahn" },
  { value: "Forensische Psychiatrie", id: "mental" },
  "Frauenarzt",
  "Frauenheilkunde und Geburtshilfe",
  "Gastroenterologe",
  "Gastroenterologie",
  "Gefäßchirurg",
  "Gefässchirurg",
  "Gefäßchirurgie",
  "Gefässchirurgie",
  "Gefäßfacharzt",
  "Gefässfacharzt",
  "Gereatrie",
  "Gesichtschirurg",
  "Gynäkologe",
  "Gynäkologie",
  "Gynäkologin",
  "Gynäkologische Endokrinologie und Reproduktionsmedizin",
  "Gynäkologische Onkologie",
  "Hals-Nasen-Ohren Arzt",
  "Hals-Nasen-Ohrenheilkunde",
  "Hämatologe",
  "Hämatologie",
  "Hämatologie und Onkologie",
  "Handchirurgie",
  "Hausarzt",
  "Haut- und Geschlechtskrankheiten",
  "Hautarzt",
  { value: "Herz-Kreislauf Facharzt", id: "herz" },
  { value: "Herzchirurg", id: "herz" },
  { value: "Herzchirurgie", id: "herz" },
  "HNO Arzt",
  "Hormonarzt",
  "Humangenetik",
  "Humangenetiker",
  "Hygiene und Umweltmedizin",
  { value: "Implantologe", id: "zahn" },
  "Innere Medizin",
  "Innere Medizin und Angiologie",
  { value: "Innere Medizin und Endokrinologie und Diabetologie", id: "herz" },
  "Innere Medizin und Gastroenterologie",
  "Innere Medizin und Hämatologie und Onkologie",
  "Innere Medizin und Kardiologie",
  "Innere Medizin und Nephrologie",
  "Innere Medizin und Pneumologie",
  "Innere Medizin und Rheumatologie",
  "Innere und Allgemeinmedizin",
  "Internist",
  { value: "Jugendpsychiater", id: "mental" },
  { value: "Jugendpsychotherapeut", id: "mental" },
  { value: "Kardiologe", id: "herz" },
  { value: "Kardiologie", id: "herz" },
  "Kardiovaskularchirurgie",
  { value: "Kieferchirurg", id: "kiefer" },
  { value: "Kinder- und Jugendmedizin", id: "mental" },
  { value: "Kinder- und Jugendpsychiatrie", id: "mental" },
  { value: "Kinder- und Jugendpsychiatrie und -psychotherapie", id: "mental" },
  "Kinder- und Jugendpsychotherapie",
  "Kinder-Hämatologie und -Onkologie",
  "Kinderarzt",
  "Kinderärztin",
  "Kinderchirurg",
  "Kinderchirurgie",
  "Kinderkardiologe",
  "Kinderkardiologie",
  { value: "Kinderpsychiater", id: "mental" },
  { value: "Kinderpsychotherapeut", id: "mental" },
  "Kinderradiologe",
  "Kinderradiologie",
  "Klinische Chemie",
  "Klinische Pharmakologie",
  "Krebsfacharzt",
  "Laboratoriumsmedizin",
  "Lungenarzt",
  "Lungenfacharzt",
  "Magen-Darm Facharzt",
  "Männerarzt",
  "Mikrobiologie, Virologie und Infektionsepidemiologie",
  { value: "Mund-Kiefer-Gesichtschirurgie", id: "kiefer" },
  "Mundchirurg",
  "Neonatologie",
  "Neonatologie",
  "Nephrologe",
  "Nephrologie",
  { value: "Nervenfacharzt", id: "mental" },
  "Neurochirurg",
  "Neurochirurgie",
  { value: "Neurologe", id: "mental" },
  { value: "Neurologie", id: "mental" },
  { value: "Neurologin", id: "mental" },
  "Neuropädiater",
  "Neuropädiatrie",
  "Neuropathologe",
  "Neuropathologie",
  "Neuroradiologe",
  "Neuroradiologie",
  "Nierenfacharzt",
  "Nuklearmedizin",
  "Onkologe",
  "Onkologie",
  "Ophthalmologe",
  "Orthopäde",
  "Orthopädie und Unfallchirurgie",
  "Pädiatrie",
  "Palliativmedizin",
  { value: "Paradontologe", id: "zahn" },
  "Pathologe",
  "Pathologie",
  "Pharmakologe",
  "Pharmakologie",
  "Pharmakologie und Toxikologie",
  "Physikalische und Rehabilitative Medizin",
  "Physikalischer Mediziner",
  "Physiologe",
  "Physiologie",
  "Plastische und Ästhetische Chirurgie",
  "Plastischer Chirurg",
  "Pneumologe",
  "Pneumologie",
  "Praktischer Arzt",
  { value: "Psychiater", id: "mental" },
  { value: "Psychiatrie", id: "mental" },
  { value: "Psychiatrie und Psychotherapie", id: "mental" },
  { value: "Psychologe", id: "mental" },
  { value: "Psychologin", id: "mental" },
  { value: "Psychosomatische Medizin", id: "mental" },
  { value: "Psychosomatische Medizin und Psychotherapie", id: "mental" },
  { value: "Psychosomatischer Mediziner", id: "mental" },
  { value: "Psychotherapeut", id: "mental" },
  { value: "Psychotherapeutin", id: "mental" },
  { value: "Psychotherapie", id: "mental" },
  "Pulmologe",
  "Radiologe",
  "Radiologie",
  "Rechtsmediziener",
  "Rechtsmedizin",
  "Reha Arzt",
  "Rehabilitativer Mediziner",
  "Rheumatologe",
  "Rheumatologie",
  "Schönheitschirurg",
  "Schwerpunkt Neuroradiologie",
  "Spezielle Geburtshilfe und Perinatalmedizin",
  "Sportmedizin",
  "Sprach-, Stimm- und kindliche Hörstörungen",
  "Stomatologe",
  "Strahlentherapeut",
  "Strahlentherapie",
  "TCM",
  "Thoraxchirurgie",
  "Toraxchirurg",
  "Toxikologe",
  "Toxikologie",
  "Traditionelle Chinesische Medizin",
  "Transfusionsmedizin",
  "Transfusionsmediziner",
  "Tropenmedizin",
  "Unfallchirurg",
  "Urologe",
  "Urologie",
  "Venerologe",
  "Viszeralchirurg",
  "Viszeralchirurgie",
  { value: "Zahn-, Mund- und Kieferheilkunde", id: "zahn" },
  { value: "Zahnarzt", id: "zahn" },
  { value: "Zahnlabor", id: "kiefer" },
  { value: "Zahnmediziner", id: "zahn" },
];
